const calculatePrecision = (asset: string, isLongPrecision = false): number => {
    if (asset === 'BTC' || asset === 'ETH') {
        return 8;
    }
    return isLongPrecision ? 4 : 2;
};

export { calculatePrecision };
